import { Spreadsheet } from '@/components/spreadsheet/spreadsheet';
import * as _ from 'lodash';
import moment from 'moment';

export class DirectSalesSpreadsheetFarmer extends Spreadsheet {
  name: string = 'Ranking_Farmer_Strategy';

  mount(dataSource: any[]) {
    const sections: Array<any> = [
      { key: 'canal_vd', text: 'CANAL VD', index: 0 },
      {
        key: 'size',
        text: 'Porte',
        index: 1
      },
      {
        key: 'cnpjRoot',
        text: 'CNPJ RAIZ',
        index: 2
      },
      {
        key: 'qtdFiliais',
        text: '# CNPJ',
        index: 3
      },
      {
        key: 'activityName',
        text: 'ATIVIDADE',
        index: 4
      },
      {
        key: 'name',
        text: 'RAZÃO SOCIAL',
        index: 5
      },
      {
        key: 'uf',
        text: 'UF',
        index: 6
      },
      {
        key: 'city',
        text: 'CIDADE-SEDE',
        index: 7
      },
      {
        key: 'expected',
        text: 'EXPECTATIVA PARA NOVA COMPRA (EM MESES)',
        index: 8
      },
      {
        key: 'frequencia',
        text: 'FREQUÊNCIA DE COMPRA (QTD. EM 5 ANOS)',
        index: 10
      },
      {
        key: 'score',
        text: 'SCORE TOTAL (0 A 100)',
        index: 12
      }
    ];

    const sectionColumns: any = {
      canal_vd: [{ key: 'salesChannelName', text: 'CANAL VD' }],
      size: [{ key: 'size', text: 'PORTE' }],
      cnpjRoot: [{ key: 'cnpjRoot', text: 'CNPJ RAIZ' }],
      qtdFiliais: [{ key: 'qtdFiliais', text: '# CNPJ' }],
      activityName: [{ key: 'activityName', text: 'ATIVIDADE' }],
      name: [{ key: 'name', text: 'RAZÃO SOCIAL' }],
      uf: [{ key: 'uf', text: 'UF' }],
      city: [{ key: 'city', text: 'CIDADE-SEDE' }],
      expected: [{ key: 'descriptionRangeExpectation', text: '' }, { key: 'descriptionExpectationScore', text: '' }],
      frequencia: [{ key: 'frequencyProspectValue', text: '' }, { key: 'descriptionFrequencyScore', text: '' }],
      score: [{ key: 'propensityScoreValue', text: 'SCORE TOTAL (0 A 100)', format: '#,0' }]
    };

    const baseStyle: any = {
      fontSize: 9,
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseHeaderStyle: any = {
      color: '#212121',
      fontSize: 9,
      bold: true,
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseColorStyle: any = {
      canal_vd: '#f9fafb',
      size: '#f9fafb',
      cnpjRoot: '#f9fafb',
      qtdFiliais: '#f9fafb',
      activityName: '#f9fafb',
      name: '#f9fafb',
      uf: '#f9fafb',
      city: '#f9fafb',
      expected: '#cecdcc',
      frequencia: '#afafaf',
      score: '#919191'
    };

    const baseBorderColorStyle: any = {
      // main: '#e0e0e0',
      // industryRetailRegistrationBySegment: '#cfd8dc',
      // industryRetailRegistrationByMarkedArea: '#ffcdd2',
      // clientRetailRegistrationByMarkedArea: '#cfd8dc',
      // clientRetailRegistrationBySegment: '#ffcdd2',
      // shareOfMarketShareInSegment: '#cfd8dc',
      // tdbShareByDealerInMarkedArea: '#ffcdd2',
      // segmentImpactInMarkedArea: '#cfd8dc',
      // dapValuesFoundNormalized: '#ffcdd2',
      // dapValuesFound: '#cfd8dc',
      // yellow: '#ffe0b2'
    };

    const baseBackgroundColorStyle: any = {
      // main: '#fafafa',
      // industryRetailRegistrationBySegment: '#f9fafb',
      // industryRetailRegistrationByMarkedArea: '#fff5f6',
      // clientRetailRegistrationByMarkedArea: '#f9fafb',
      // clientRetailRegistrationBySegment: '#fff5f6',
      // shareOfMarketShareInSegment: '#f9fafb',
      // tdbShareByDealerInMarkedArea: '#fff5f6',
      // segmentImpactInMarkedArea: '#f9fafb',
      // dapValuesFoundNormalized: '#fff5f6',
      // dapValuesFound: '#f9fafb',
      // yellow: '#fffbf5'
    };

    const headerStyle = _.reduce(
      baseColorStyle,
      (acc: any, val: string, key: string) => {
        acc[key] = _.assign({}, baseHeaderStyle, {
          textAlign: 'center',
          background: baseColorStyle[key]
        });
        return acc;
      },
      {}
    );

    const getCellStyle = (key: any) => {
      return _.assign({}, baseStyle, {
        textAlign: 'center',
        background: baseBackgroundColorStyle[key],
        borderLeft: { color: baseBorderColorStyle[key], size: 1 },
        borderRight: { color: baseBorderColorStyle[key], size: 1 },
        borderTop: { color: baseBorderColorStyle[key], size: 1 },
        borderBottom: { color: baseBorderColorStyle[key], size: 1 }
      });
    };

    const dataSourceGroup = { data: dataSource };
    this.name = `RANKING_FARMER_STRATEGY`;

    this.workbookOptions = {
      sheets: _.map(
        dataSourceGroup,
        (data: any, name: string) =>
          ({
            name: `RANKING FARMER STRATEGY`,
            frozenColumns: 3,
            frozenRows: 1,
            // filter: {
            //   ref: `A2:${this.columnIndex[12]}${data.length + 1}`,
            //   columns: []
            // },
            rows: [
              {
                height: 30,
                cells: [
                  ..._.map(sections, (section: any) =>
                    _.assign({}, headerStyle[section.key], {
                      value: section.text,
                      index: section.index,
                      borderLeft: { color: baseBorderColorStyle[section.key], size: 1 },
                      borderRight: { color: baseBorderColorStyle[section.key], size: 1 }
                    })
                  )
                ]
              },
              ..._.map(data, d => {
                return {
                  cells: [
                    ..._(sectionColumns)
                      .map((columns: any, key: any) =>
                        _.map(columns, (cell: any, index: number) => {
                          // if (
                          //   [
                          //     'industryRetailRegistrationBySegment',
                          //     'industryRetailRegistrationByMarkedArea',
                          //     'clientRetailRegistrationByMarkedArea',
                          //     'clientRetailRegistrationBySegment',
                          //     'shareOfMarketShareInSegment',
                          //     'tdbShareByDealerInMarkedArea',
                          //     'segmentImpactInMarkedArea',
                          //     'dapValuesFoundNormalized',
                          //     'dapValuesFound'
                          //   ].some((k: string) => key === k)
                          // ) {
                          //   return _.assign({}, getCellStyle(cell.color || key), {
                          //     value: d[key][index][cell.key],
                          //     format: cell.format
                          //   });
                          // }
                          return _.assign({}, getCellStyle(cell.color || key), {
                            value: d[cell.key],
                            format: cell.format
                          });
                        })
                      )
                      .flatten()
                      .value()
                  ]
                };
              })
            ],
            columns: [
              {
                index: 0,
                width: 100
              },
              {
                index: 1,
                width: 100
              },
              {
                index: 2,
                width: 100
              },
              {
                index: 3,
                width: 75
              },
              {
                index: 4,
                width: 500
              },
              {
                index: 5,
                width: 300
              },
              {
                index: 6,
                width: 50
              },
              {
                index: 7,
                width: 300
              },
              {
                index: 8,
                width: 150
              },
              {
                index: 9,
                width: 150
              },
              {
                index: 10,
                width: 150
              },
              {
                index: 11,
                width: 150
              },
              {
                index: 12,
                width: 150
              }
            ],
            showGridLines: false,
            mergedCells: [`I1:J1`, `K1:L1`]
          } as any)
      )
    };

    return this;
  }
}
